export default __webpack_public_path__ + "static/media/Poppinsregular.87fcf9bb.woff2";